if (!customElements.get('apex-facet-search')) {
  class ApexFacetSearch extends HTMLElement {
    static queries = new Map();

    connectedCallback() {
      this.input = this.querySelector('input');
      this.clearButton = this.querySelector('button');
      this.emptyMessage = this.querySelector('[role="status"]');
      this.details = this.closest('.js-filter');
      if (!this.input || !this.details) return;
      this.key = `${window.location.pathname}|${this.dataset.context}|${this.dataset.filterKey}`;
      this.input.value = ApexFacetSearch.queries.get(this.key) || '';
      this.onInput = (event) => {
        event.stopPropagation();
        this.update();
      };
      this.onKeyDown = (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          event.stopPropagation();
        }
        if (event.key === 'Escape' && this.input.value) {
          event.preventDefault();
          event.stopPropagation();
          this.consumeEscape = true;
          this.clear();
        }
      };
      this.onKeyUp = (event) => {
        if (event.key === 'Escape' && this.consumeEscape) {
          event.stopPropagation();
          this.consumeEscape = false;
        }
      };
      this.onClear = (event) => {
        if (!this.clearButton.contains(event.target)) return;
        event.preventDefault();
        event.stopPropagation();
        this.clear();
      };
      this.input.addEventListener('input', this.onInput);
      this.input.addEventListener('search', this.onInput);
      this.input.addEventListener('keydown', this.onKeyDown);
      this.input.addEventListener('keyup', this.onKeyUp);
      this.addEventListener('click', this.onClear, true);
      this.observer = new MutationObserver((mutations) => {
        if (mutations.some((mutation) => !this.contains(mutation.target))) this.update();
      });
      this.observer.observe(this.details, { childList: true, subtree: true });
      this.hidden = false;
      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.input?.removeEventListener('input', this.onInput);
      this.input?.removeEventListener('search', this.onInput);
      this.input?.removeEventListener('keydown', this.onKeyDown);
      this.input?.removeEventListener('keyup', this.onKeyUp);
      this.removeEventListener('click', this.onClear, true);
    }

    normalize(value) {
      return value.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/(\d)r(?=\d)/g, '$1').replace(/[^a-z0-9]/g, '');
    }

    clear() {
      this.input.value = '';
      this.update();
      this.input.focus();
    }

    update() {
      const query = this.normalize(this.input.value.trim());
      ApexFacetSearch.queries.set(this.key, this.input.value);
      this.clearButton.hidden = !this.input.value;
      this.details.toggleAttribute('data-apex-search-active', Boolean(query));
      let matches = 0;
      this.details.querySelectorAll('.facets__item, .mobile-facets__item').forEach((item) => {
        const label = item.querySelector('.facet-checkbox__text-label')?.textContent || '';
        const matchesQuery = !query || this.normalize(label).includes(query);
        const selected = Boolean(item.querySelector('input[type="checkbox"]:checked'));
        if (matchesQuery) matches += 1;
        const hide = Boolean(query) && !matchesQuery && !selected;
        if (hide && item.contains(document.activeElement)) this.input.focus();
        item.classList.toggle('apex-facet-search-match', Boolean(query) && (matchesQuery || selected));
        item.classList.toggle('apex-facet-search-hidden', hide);
      });
      this.emptyMessage.hidden = !query || matches > 0;
    }
  }
  customElements.define('apex-facet-search', ApexFacetSearch);
}
